import classNames from "clsx";

import { FormControlProps } from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { FiX } from "react-icons/fi";

import { MaskedFormControl } from "@/components/FormControl/MaskedFormControl";
import { SkeletonWrapper } from "@/components/SkeletonWrapper";

export type Props = FormControlProps & {
	systolicInputProps?: any;
	diastolicInputProps?: any;
	skeleton?: boolean;
	labelClassName?: string;
	inputClassName?: string;
	containerClassName?: string;
	solid?: boolean;
};

export function BloodPressure({
	systolicInputProps,
	diastolicInputProps,
	skeleton,
	labelClassName,
	inputClassName,
	containerClassName,
	solid = true,
}: Props) {
	return (
		<>
			{skeleton ? (
				<SkeletonWrapper />
			) : (
				<Form.Group className={classNames("mb-3", containerClassName)}>
					<Form.Label
						className={classNames("mb-2 text-gray-800", labelClassName)}
						htmlFor={systolicInputProps?.id || "systolic-blood-pressure"}
					>
						Pressão Arterial
					</Form.Label>

					<InputGroup>
						<MaskedFormControl
							id={systolicInputProps?.id || "systolic-blood-pressure"}
							mask="000"
							{...systolicInputProps}
							className={classNames(
								"h-38px",
								solid && "form-control-solid",
								inputClassName
							)}
						/>

						<FiX className="mx-1 fs-9 d-flex align-self-center large-icon" />

						<MaskedFormControl
							mask="000"
							{...diastolicInputProps}
							className={classNames(
								"h-38px",
								solid && "form-control-solid",
								inputClassName
							)}
						/>
					</InputGroup>
				</Form.Group>
			)}
		</>
	);
}
